angular.module('unergie.main')
.factory('EnvUtils', (ReferencesService) => {
    const data = {
        frontUrl: undefined,
        selfcareUrl: undefined,
    }

    if (window.location.hostname.includes('local.')) {
        data.frontUrl = 'https://int.plum.fr'
        data.selfcareUrl = 'https://local.unergie.com:3010'
        data.timetableRegenUrl = 'https://local.unergie.com:3004'
    } else if (window.location.hostname.includes('.int.')) {
        data.frontUrl = 'https://int.plum.fr'
        data.selfcareUrl = 'https://espace-client.int.plum.fr'
        data.timetableRegenUrl = `${data.selfcareUrl}/choix-regeneration-echeancier`
    } else if (window.location.hostname.includes('.preprod.')) {
        data.frontUrl = 'https://preprod.plum.fr'
        data.selfcareUrl = 'https://espace-client.preprod.plum.fr'
        data.timetableRegenUrl = `${data.selfcareUrl}/choix-regeneration-echeancier`
    } else {
        data.frontUrl = 'https://plum.fr'
        data.selfcareUrl = 'https://espace-client.plum.fr'
        data.timetableRegenUrl = `${data.selfcareUrl}/choix-regeneration-echeancier`
    }

    return data
})
